import React from "react";
import PropTypes from "prop-types";
import Page from "../../components/Page";

import CenteredPageContentContainer from "../../components/CenteredPageContentContainer";
import PaperContainer from "../../components/PaperContainer";
import ShiftForm from "../../components/forms/ShiftForm";
import { FormMode } from "../../types/enums";

const UpdateShiftPage = (props) => (
  <Page enableGoBack title="Dienst wijzigen">
    <CenteredPageContentContainer>
      <PaperContainer title="Dienst wijzigen">
        <ShiftForm
          mode={FormMode.UPDATE}
          shiftId={props.match.params.shift_id}
        />
      </PaperContainer>
    </CenteredPageContentContainer>
  </Page>
);

UpdateShiftPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      shift_id: PropTypes.string.isRequired,
    }),
  }),
};

export default UpdateShiftPage;



// WEBPACK FOOTER //
// ./src/pages/Shift/UpdateShiftPage.js